module.exports = __webpack_public_path__ + "img/shadom.9a53f2a4.png";